var exports = {
  "Q": "content__1FYOuk",
};

module.exports = exports;
